<template>
  <div class="t-success">
    <svg width="99" height="99" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!--            <circle cx="49.5" cy="49.5" r="49.5" fill="#1BBA7D"/>-->
      <circle cx="49.5" cy="49.5" r="49.5" fill="#33BD82" />
      <path d="M26 50.7805L41.1488 66L73 34" stroke="white" stroke-width="5" stroke-linejoin="round" />
    </svg>
    <h3 class="t-success__title">{{ props.title }}</h3>
    <div class="t-success__text">{{ props.text }}</div>
    <div class="t-success__row">
      <a v-if="props.btnEvent" v-link href="/events" @click="modalClose" class="t-btn _back t-success__btn _events">{{
        props.btnEvent
      }}</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"

export default {
  props: ["props"],
  methods: {
    ...mapActions("modal", ["modalClose"]),
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/success.vue